import { Box, Divider, IconButton, Modal, ModalProps, Stack, Typography } from '@mui/material';
import { XClose } from 'untitledui-js-base';
import { modalSx } from '../../styles/tokens';

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: 'background.paper',
  ...modalSx,
  maxWidth: '90vw'
};

export const BasicModal = ({ onClose, open, children, title, ...props }: ModalProps) => {
  return (
    <Modal open={open} onClose={onClose} {...props}>
      <Box sx={style}>
        <Stack width={1} justifyContent="space-between" flexDirection="row">
          <Box p={1}>{title && <Typography variant="h6">{title}</Typography>}</Box>
          <IconButton sx={{ width: '3rem', height: '3rem' }} onClick={(event) => onClose?.(event, 'escapeKeyDown')}>
            <XClose />
          </IconButton>
        </Stack>
        <Divider />
        <Box sx={{ marginTop: '1rem', px: 4, pb: 4 }}>{children}</Box>
      </Box>
    </Modal>
  );
};
